import axios from 'axios'
import experiments, { EXPERIMENT_STATUSES } from "@/constants/experiments";


const ExperimentsTest = async ({ campaignId, user_uuid }) => {
    return Promise.allSettled(experiments.map((item) => {
        return axios.post(`${process.env.VUE_APP_URL}/exp.php/${item.exp_id}/users/${user_uuid}`, {
            profile: {
                campaignID: campaignId
            }
        }, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
    })).then((response) => {
        return response.reduce((result, { status, value }) => {
            const validStatuses = [EXPERIMENT_STATUSES.NEW_ASSIGNMENT, EXPERIMENT_STATUSES.EXISTING_ASSIGNMENT]
            if (status === "fulfilled" && validStatuses.includes(value?.data?.status)) {
                const requestUrl = value.config.url

                let startIndex = requestUrl.indexOf("exp.php/") + "exp.php/".length;
                let endIndex = requestUrl.indexOf("/users");

                let exp_id = requestUrl.substring(startIndex, endIndex);
                result = { ...value.data, exp_id }
            }
            return result
        }, {})
    })
}

export default ExperimentsTest
